// @flow

const loginStyles = {
  headerLogo: (theme) => ({
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(1),
    textAlign: 'center'
  }),
  contentCtr: (theme) => ({
    position: 'relative',
    maxWidth: 540,
    paddingTop: theme.spacing(3.75),
    paddingLeft: theme.spacing(2.5),
    paddingRight: theme.spacing(2.5),
    margin: '0 auto',
    textAlign: 'left',
    zIndex: 0
  }),
  formTitle: (theme) => ({
    textAlign: 'center',
    marginBottom: theme.spacing(2)
  }),
  inputForm: (theme) => ({
    backgroundColor: 'white',
    borderRadius: 0,
    padding: `${theme.spacing(2)} 30px`,
    minWidth: '100%',
    textAlign: 'left',
    margin: 0,
    fontSize: '1rem',
    '&::placeholder': {
      color: '#a3c2d9'
    }
  }),
  formElt: (theme) => ({
    borderTop: 0,
    borderRight: '1px #B4CEE1 solid',
    borderLeft: '1px #B4CEE1 solid',
    borderBottom: '1px #B4CEE1 solid',
    outline: 0,
    '&:first-of-type': {
      borderTop: '1px #B4CEE1 solid'
    }
  }),
  signin: (theme) => ({
    width: '100%',
    borderRadius: 0,
    fontWeight: 600,
    padding: `${theme.spacing(1.5)} 30px`
  }),
  helpLink: (theme) => ({
    marginTop: theme.spacing(2),
    textAlign: 'center',
    textDecoration: 'underline',
    fontSize: '0.8rem'
  })
};

export default loginStyles;